import { render, staticRenderFns } from "./Cm-overview.vue?vue&type=template&id=4b80e896"
import script from "./Cm-overview.vue?vue&type=script&lang=js"
export * from "./Cm-overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports